import React, { useState, useEffect } from 'react';
import SearchBar from '../Shared/SearchBar/SearchBar';
import MapView from '../Shared/Utility/LeafletMap/MapView';
import ToggleViewButton from './ToggleViewButton';
import MapLegend from '../Shared/Utility/LeafletMap/MapLegend';
import ChannelView from './ChannelView';
import { useFirstMountState } from '../../hooks/useFirstMountState';

const Index = ({userId}) => {

  const [channels, setChannels] = useState([])
  const [term, setTerm] = useState('')
  const [viewMode, setViewMode] = useState('map');
  const [activeChannelTab, setActiveChannelTab] = useState('all');
  const isFirstMount = useFirstMountState();

  useEffect(function onInitialLoad() {
    if (!isFirstMount) return;

    const viewMap = {
      commercial: 'Channel::CommercialChannel',
      academic: 'Channel::AcademicChannel',
    };

    const viewParam = new URLSearchParams(window.location.search).get('view');
    const channelType = viewMap[viewParam];

    if (channelType) {
      setViewMode('map');
      setActiveChannelTab(channelType);
    }
  }, []);


  useEffect(() => {
    fetchChannels();
  }, [term])

  const fetchChannels = () => {
    $.ajax({
      type: 'GET',
      url: '/channels/all',
      dataType: 'json',
      data: {
        searchTerm: term,
      },
      success: function(res) {
        setChannels(res.cards);
      }
    });
  }

  const renderView = () => {
    if (viewMode === 'list') {
      return <ChannelView channels={channels} userId={userId} activeChannelTab={activeChannelTab} />
    } else if (viewMode === 'map') {
      return (
        <>
          <MapLegend />
          <MapView channels={channels} height={"700px"} userId={userId} />        
        </>
      )
    }
  }
  
  return (
    <div className='row all-channels-container'>
      <div className="top-section-container large-11 medium-11 small-12 columns small-centered">
        <h4 className='all-channels-heading'>CUREUS CHANNELS</h4>
        <h1 className='all-channels-title'>Shining a spotlight on dozens of leading societies, universities, and hospitals</h1>
      </div>

      <div className="row small-collapse">
        <div className='small-12 text-center columns'>
          <ToggleViewButton viewMode={viewMode} setViewMode={setViewMode} />
        </div>
      </div>

      <div className="row small-collapse">
        <div className='small-12 columns'>
          {viewMode === 'list' && <SearchBar url={'/channels/all'} placeHolder = {'Search for a specific channel here.'} isFilterMenuOpen={false} setIsFilterMenuOpen={{}} setCards={setChannels} page={"channels"} isFilterRequired={false} />}
        </div>
      </div>

      <div className="row small-collapse">
        <div className="small-12 columns">
          {viewMode === 'list' &&
            <div className="channels-filter-container">
              <div
                className={`channels-filter-button ${activeChannelTab === 'all' ? "active" : ""}`}
                onClick={() => setActiveChannelTab('all')}>
                All
              </div>
              <div
                className={`channels-filter-button ${activeChannelTab === 'Channel::AcademicChannel' ? "active" : ""}`}
                onClick={() => setActiveChannelTab('Channel::AcademicChannel')}>
                Academic Channels
              </div>
              <div
                className={`channels-filter-button ${activeChannelTab === 'Channel::CommercialChannel' ? "active" : ""}`}
                onClick={() => setActiveChannelTab('Channel::CommercialChannel')}>
                Commercial Channels
              </div>
            </div>
          }
          {renderView()}
        </div>
      </div>
    </div>
  )
}

export default Index;